import axios from '../../store/vue-axios'
import User from "@/store/models/user";
import router from '../../router'

export const actions = {

  async login({commit, state, dispatch}, data) {
    const response = await axios.post("account/login", data)

    const authToken = response.data.authToken;
    commit('SET_AUTH_TOKEN', {authToken}, {root: true})

    User.fetch(response.data.user.username)
    localStorage.setItem('currentUser', response.data.user.username)

    return response
  },
  async logout({commit, state, dispatch}, data) {
    const response = await axios.post("account/logout")

    console.log("logout -- module")

    localStorage.removeItem("currentUser")
    commit('SET_AUTH_TOKEN', null, {root: true})

    return router.push({ name: 'public-auth-login' })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js